const SectionTitle = ({id, children, direction}) => {
    return ( 
        <h1 id={id} data-aos={direction===1?'fade-left':'fade-right'} className="font-bold text-3xl md:text-4xl">
            {children}
        </h1>
    );
}

export default SectionTitle;